import React from 'react';

import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

/* Styles */
import css from '../nibTable.module.sass';

const Pagination = ({
  gotoPage,
  canPreviousPage,
  previousPage,
  nextPage,
  canNextPage,
  pageOptions,
  pageIndex,
  setPageSize,
  pageSize,
  pageCount,
}) => {
  const pagination = (c, m) => {
    let current = c,
      last = m,
      delta = 2,
      left = current - delta,
      right = current + delta + 1,
      range = [],
      rangeWithDots = [],
      l;

    for (let i = 1; i <= last; i++) {
      if (i == 1 || i == last || (i >= left && i < right)) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  };

  return (
    <div className={css.pagination}>
      <div className={css.railWayWrap}>
        <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          <DoubleArrowIcon style={{ transform: 'rotate(180deg)' }} />
        </Button>
        <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
          <KeyboardArrowLeftIcon />
        </Button>

        <List className={css.railWay} dense>
          {pagination(pageIndex + 1, pageCount).map((p) => (
            <ListItem
              button
              onClick={() => gotoPage(p - 1)}
              key={p}
              className={parseInt(p) === parseInt(pageIndex) + 1 ? css.active : ''}
            >
              <ListItemText primary={p} />
            </ListItem>
          ))}
        </List>

        <Button onClick={() => nextPage()} disabled={!canNextPage}>
          <KeyboardArrowRightIcon />
        </Button>
        <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          <DoubleArrowIcon />
        </Button>
      </div>

      {/* <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select> */}
    </div>
  );
};

export default Pagination;
